import { Switch } from '@accure/ui';

import { Tooltip } from '@/components/ui/tooltip';

export type NoiseFilterProps = {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
};

export function NoiseFilter({
  value,
  onChange,
  disabled = false,
}: NoiseFilterProps) {
  const switchElement = (
    <Switch
      id="filter-noise"
      value={value}
      onChange={onChange}
      disabled={disabled}
      aria-label="Filter Noise"
    />
  );

  return (
    <div className="flex flex-col items-center justify-center gap-1">
      <label className="cursor-pointer text-sm" htmlFor="filter-noise">
        Clean Data
      </label>
      <div className="flex items-center justify-center p-1">
        <Tooltip
          content="Noise filtering only available on lowest level"
          hide={!disabled}
          position="bottom"
          delay
        >
          {switchElement}
        </Tooltip>
      </div>
    </div>
  );
}
